export const DoubleSpace = () => {
    return <span style={{marginInline: 4}} />
}